/* Card swatch hover image swap.
 * Wires both:
 *  - .card__swatches inside snippets/card-product.liquid (collection / search / featured)
 *  - .product-showcase__swatches inside sections/product-showcase.liquid (homepage)
 * On mouseenter of a swatch, swap the closest card's primary <img> src to the
 * variant's featured_image. Restore on mouseleave.
 */
(function () {
  function initCard(group) {
    if (group.dataset.swatchesWired === '1') return;
    group.dataset.swatchesWired = '1';

    /* Find the card root and its primary image */
    var card =
      group.closest('.card-wrapper') ||
      group.closest('.product-showcase__card') ||
      group.closest('.card') ||
      group.parentElement;
    if (!card) return;

    var primaryImg =
      card.querySelector('.product-showcase__img--primary') ||
      card.querySelector('.media img') ||
      card.querySelector('img');
    if (!primaryImg) return;

    var originalSrc = primaryImg.getAttribute('src');
    var originalSrcset = primaryImg.getAttribute('srcset');

    /* Optional batch-number element: "Limited batch of <span data-card-batch>X</span>"
       Only present on Limited products. Restore on group leave. */
    var batchEl = card.querySelector('[data-card-batch]');
    var originalBatch = batchEl ? batchEl.textContent : null;

    /* Container-level hover: toggle the suppress-fade class and restore image
       only when the cursor leaves the swatch group entirely. */
    group.addEventListener('mouseenter', function () {
      card.classList.add('is-swatch-hover');
    });
    group.addEventListener('mouseleave', function () {
      card.classList.remove('is-swatch-hover');
      primaryImg.setAttribute('src', originalSrc);
      if (originalSrcset) primaryImg.setAttribute('srcset', originalSrcset);
      if (batchEl && originalBatch != null) batchEl.textContent = originalBatch;
    });

    /* Per-swatch: swap the image src + batch number on enter. */
    group.querySelectorAll('a[data-variant-image]').forEach(function (sw) {
      var variantImg = sw.getAttribute('data-variant-image');
      var variantBatch = sw.getAttribute('data-variant-batch');
      if (!variantImg) return;
      sw.addEventListener('mouseenter', function () {
        primaryImg.setAttribute('src', variantImg);
        primaryImg.removeAttribute('srcset');
        if (batchEl && variantBatch) batchEl.textContent = variantBatch;
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-card-swatches]').forEach(initCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* Re-init when sections re-render (e.g. after AJAX collection filter) */
  document.addEventListener('shopify:section:load', initAll);
})();
